import { render, staticRenderFns } from "./RecruitBuy.vue?vue&type=template&id=c5429ac0&scoped=true&"
import script from "./RecruitBuy.vue?vue&type=script&lang=js&"
export * from "./RecruitBuy.vue?vue&type=script&lang=js&"
import style0 from "./RecruitBuy.vue?vue&type=style&index=0&id=c5429ac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5429ac0",
  null
  
)

export default component.exports